import PropTypes from "prop-types";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import clsx from "clsx";
import Rating from "./sub-components/ProductRating";
import ProductModal from "./ProductModal";
import { addToCart } from "../../store/slices/cart-slice";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import { addToCompare } from "../../store/slices/compare-slice";
import ReactStars from "react-rating-stars-component";
import { useTranslation } from "react-i18next";

const ProductGridListSingle = ({
  product,
  currency,
  cartItem,
  wishlistItem,
  compareItem,
  spaceBottomClass,
  layout,
}) => {
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  return (
    <Fragment>
      {layout != "list" && (
        <div className={clsx("product-wrap-7", spaceBottomClass)}>
          <div className="product-img">
            <Link to={"/product/" + product?.id}>
              <img
                className="default-img rounded-3"
                src={`${import.meta.env.VITE_REACT_APP_API_URL}/${product.img}`}
                alt="product thumb"
                loading="lazy"
              />
              {product?.images?.length > 1 ? (
                <img
                  className="hover-img rounded-3 default-img"
                  src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                    product?.images?.[0]
                  }`}
                  alt="product thumb"
                  loading="lazy"
                />
              ) : (
                ""
              )}
            </Link>
            {product?.discount || product?.isFeatured ? (
              <div className="product-img-badges">
                {product?.discount ? (
                  <span className="pink">{product?.discount}%-</span>
                ) : (
                  ""
                )}
                {product?.isFeatured ? (
                  <span className="purple">{t("is_featured")}</span>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
            <div className="d-md-none d-flex flex-col product-action-mobile w-100 mt-2">
              {product?.quantity ? (
                <button
                  onClick={() => dispatch(addToCart(product))}
                  className={
                    cartItem !== undefined && cartItem.quantity > 0
                      ? "active w-100 rounded-1"
                      : "w-100 rounded-1"
                  }
                  disabled={cartItem !== undefined && cartItem.quantity > 0}
                  title={
                    cartItem !== undefined
                      ? t("item_added_to_cart")
                      : t("add_to_cart")
                  }
                >
                  {cartItem !== undefined
                    ? t("item_added_to_cart")
                    : t("add_to_cart")}
                </button>
              ) : (
                <button disabled className="active" title="لا يوجد مخزون">
                  {t("out_of_stock")}
                </button>
              )}
            </div>
            <div className="product-action-2 d-md-flex d-none">
              {product?.quantity ? (
                <button
                  onClick={() => dispatch(addToCart(product))}
                  className={
                    cartItem !== undefined && cartItem.quantity > 0
                      ? "active rounded"
                      : "rounded"
                  }
                  disabled={cartItem !== undefined && cartItem.quantity > 0}
                  title={
                    cartItem !== undefined
                      ? t("item_added_to_cart")
                      : t("add_to_cart")
                  }
                >
                  <i className="fa fa-shopping-cart"></i>
                </button>
              ) : (
                <button
                  disabled
                  className="active rounded"
                  title={t("out_of_stock")}
                >
                  <i className="fa fa-shopping-cart"></i>
                </button>
              )}

              <button
                className="rounded"
                onClick={() => setModalShow(true)}
                title="Quick View"
              >
                <i className="fa fa-eye"></i>
              </button>

              <button
                className={
                  compareItem !== undefined ? "active rounded" : "rounded"
                }
                disabled={compareItem !== undefined}
                title={
                  compareItem !== undefined
                    ? "Added to compare"
                    : "Add to compare"
                }
                onClick={() => dispatch(addToCompare(product))}
              >
                <i className="fa fa-retweet"></i>
              </button>
            </div>
            <div className="pro-wishlist-2">
              <button
                className={
                  wishlistItem !== undefined ? "active rounded" : "rounded"
                }
                disabled={wishlistItem !== undefined}
                title={
                  wishlistItem !== undefined
                    ? "Added to wishlist"
                    : "Add to wishlist"
                }
                onClick={() => dispatch(addToWishlist(product))}
              >
                <i className="fa fa-heart-o" />
              </button>
              <button
                className="d-md-none d-flex position-absolute rounded"
                style={{ top: "33px", left: "0px" }}
                onClick={() => setModalShow(true)}
                title="Quick View"
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
          </div>
          <div className="product-content">
            <h4 className="mt-2 truncate-text fs-6 fw-semibold mb-0">
              <Link className="w-100" to={"/product/" + product?.id}>
                {" "}
                {i18n?.language === "ar" ? product?.name : product?.name_en}
              </Link>
            </h4>
            <div className="rating-review">
              <div className="product-list-rating m-0">
                <ReactStars
                  count={5}
                  value={product?.rating_avg}
                  size={20}
                  edit={false}
                  activeColor="#ffd700"
                  color="#e4e5e9"
                />
              </div>
            </div>

            <div className="price-2 d-flex align-items-center justify-content-start gap-1">
              {product?.discount ? (
                <Fragment>
                  <span className="old text-decoration-line-through">
                    {Number(product?.price)?.toFixed(2)}{" "}
                    {i18n?.language == "ar"
                      ? import.meta.env.VITE_REACT_APP_CURRENCY
                      : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                  </span>
                  <br />{" "}
                  <span className="fw-bold text-primary fs-6">
                    {Number(
                      product?.price -
                        product?.price * (product?.discount / 100)
                    )?.toFixed(2)}{" "}
                    {i18n?.language == "ar"
                      ? import.meta.env.VITE_REACT_APP_CURRENCY
                      : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                  </span>
                </Fragment>
              ) : (
                <span>
                  {Number(product?.price)?.toFixed(2)}{" "}
                  {i18n?.language == "ar"
                    ? import.meta.env.VITE_REACT_APP_CURRENCY
                    : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="shop-list-wrap mb-30">
        <div className="row w-100">
          <div className="col-xl-6 col-lg-4 col-sm-5 col-7">
            <div className="product-wrap-7 h-100">
              <div className="product-img">
                <Link to={"/product/" + product?.id}>
                  <img
                    className="default-img img-fluid rounded-3 h-100"
                    src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                      product?.img
                    }`}
                    alt="product thumb"
                    style={{ height: "200px" }}
                    loading="lazy"
                  />
                  {product?.images?.length > 1 ? (
                    <img
                      className="hover-img img-fluid rounded-3 h-100"
                      src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                        product.images[0]
                      }`}
                      alt="product thumb"
                      style={{ maxHeight: "100%", height: "200px" }}
                      loading="lazy"
                    />
                  ) : (
                    ""
                  )}
                </Link>
                {product?.discount || product?.isFeatured ? (
                  <div className="product-img-badges">
                    {product?.discount ? (
                      <span className="pink">{product?.discount}%-</span>
                    ) : (
                      ""
                    )}
                    {product?.isFeatured ? (
                      <span className="purple">{t("is_featured")}</span>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-8 col-sm-7 col-12 p-md-0">
            <div className="shop-list-content">
              <h3 className="text-truncate fs-5 fw-medium">
                <Link to={"/product/" + product?.id}>
                  {" "}
                  {i18n?.language === "ar" ? product?.name : product?.name_en}
                </Link>
              </h3>
              <div className="product-list-rating d-flex">
                <ReactStars
                  count={5}
                  value={product?.rating_avg}
                  size={20}
                  edit={false}
                  activeColor="#ffd700"
                  color="#e4e5e9"
                />
              </div>
              <div className="product-list-price d-flex gap-2">
                {product?.discount ? (
                  <Fragment>
                    <span className="old fw-bold">
                      {Number(product?.price)?.toFixed(2)}{" "}
                      {i18n?.language == "ar"
                        ? import.meta.env.VITE_REACT_APP_CURRENCY
                        : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                    </span>
                    <br />{" "}
                    <span>
                      {Number(
                        product?.price -
                          product?.price * (product?.discount / 100)
                      )?.toFixed(2)}{" "}
                      {i18n?.language == "ar"
                        ? import.meta.env.VITE_REACT_APP_CURRENCY
                        : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                    </span>
                  </Fragment>
                ) : (
                  <span>
                    {Number(product?.price)?.toFixed(2)}{" "}
                    {i18n?.language == "ar"
                      ? import.meta.env.VITE_REACT_APP_CURRENCY
                      : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
                  </span>
                )}
              </div>

              {product?.description || product?.description_en ? (
                <p
                  className="product-list-desc "
                  style={{
                    textOverflow: "ellipsis",
                    height: "40px",
                    overflow: "hidden",
                    whiteSpace: "wrap",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    lineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      i18n?.language === "ar"
                        ? product?.description
                        : product?.description_en,
                  }}
                ></p>
              ) : (
                ""
              )}

              <div className="shop-list-actions d-flex align-items-center mt-2">
                <div className="shop-list-btn btn-hover">
                  {product?.quantity && product?.quantity > 0 ? (
                    <button
                      onClick={() => dispatch(addToCart(product))}
                      className={
                        cartItem !== undefined && cartItem.quantity > 0
                          ? "active bg-primary"
                          : ""
                      }
                      disabled={cartItem !== undefined && cartItem.quantity > 0}
                      title={
                        cartItem !== undefined
                          ? t("item_added_to_cart")
                          : t("add_to_cart")
                      }
                    >
                      {" "}
                      <i className="pe-7s-cart"></i>{" "}
                      {cartItem !== undefined && cartItem.quantity > 0
                        ? t("item_added_to_cart")
                        : t("add_to_cart")}
                    </button>
                  ) : (
                    <button disabled className="active">
                      {t("out_of_stock")}
                    </button>
                  )}
                </div>

                <div className="shop-list-wishlist ml-10">
                  <button
                    className={wishlistItem !== undefined ? "active" : ""}
                    disabled={wishlistItem !== undefined}
                    title={
                      wishlistItem !== undefined
                        ? "Added to wishlist"
                        : "Add to wishlist"
                    }
                    onClick={() => dispatch(addToWishlist(product))}
                  >
                    <i className="pe-7s-like" />
                  </button>
                </div>
                <div className="shop-list-compare ml-10">
                  <button
                    className={compareItem !== undefined ? "active" : ""}
                    disabled={compareItem !== undefined}
                    title={
                      compareItem !== undefined
                        ? "Added to compare"
                        : "Add to compare"
                    }
                    onClick={() => dispatch(addToCompare(product))}
                  >
                    <i className="pe-7s-shuffle" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* product modal */}
      <ProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        currency={currency}
        wishlistItem={wishlistItem}
        compareItem={compareItem}
      />
    </Fragment>
  );
};

ProductGridListSingle.propTypes = {
  cartItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({}),
  currency: PropTypes.shape({}),
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.shape({}),
};

export default ProductGridListSingle;
